import React from "react";

/**
 * Breadcrumbs. Accepts an array of `{label, href?}`. Last entry renders
 * as the current page (no link).
 * @param {Object} props
 * @param {Array<{label:string, href?:string}>} props.items
 */
export function Breadcrumbs({ items = [] }) {
  return (
    <nav className="ds-crumbs" aria-label="Breadcrumb">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {last
              ? <span className="current">{c.label}</span>
              : <a href={c.href || "#"}>{c.label}</a>}
            {!last && <span className="sep">›</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
